<script setup>
import { watch, ref } from 'vue';
import MultiSelect from 'primevue/multiselect';
import InputSwitch from 'primevue/inputswitch';
import { formatarDataHora } from '@/utils/formatarDataHora';
import { storeToRefs } from 'pinia';
import { useCadernoStore } from './useCardernoStore';
const store = useCadernoStore();
const { anotacoes, datasComRegistro, anotacoesBrutas, alunosSemAnotacoes, opcoesPlanos, planosSelecionados} = storeToRefs(store);

const datasSelecionadas = ref([]);


watch(datasSelecionadas, () => {
    filtrarAnotacoes();
}, { deep: true });

watch(alunosSemAnotacoes, () => {
    filtrarAnotacoes();
}, { deep: true });

watch(planosSelecionados, () => {
    filtrarAnotacoesPorPlanos();
}, { deep: true });


function filtrarAnotacoes() {
    if (datasSelecionadas.value.length > 0) {
        anotacoes.value = anotacoesBrutas.value.map(estudante => {
            const anotacoesFiltradas = estudante.anotacoes.filter(a => datasSelecionadas.value.includes(formatarDataHora(a.data, 'data')));
            return {
                ...estudante,
                anotacoes: anotacoesFiltradas
            };
        });
    } else {
        anotacoes.value = [...anotacoesBrutas.value];
    }

    anotacoes.value.map(estudante => {
        let numeroDaAnotacao = 1;
        estudante.anotacoes.map(a => {
            if (numeroDaAnotacao < 3) {
                a.condicao = 'exibir'
            } else {
                a.condicao = 'ocultar'
            }
            numeroDaAnotacao++;
        })
    })

    if (alunosSemAnotacoes.value == true) {
        anotacoes.value = anotacoes.value.filter(estudante => estudante.anotacoes.length == 0)
    }
}

function filtrarAnotacoesPorPlanos(){
    if(planosSelecionados.value.length == 0){
        anotacoes.value = [...anotacoesBrutas.value];
        return
    }

    anotacoes.value = anotacoesBrutas.value.map(estudante => {
        const anotacoesFiltradas = estudante.anotacoes.filter(nota => planosSelecionados.value.includes(nota.plano));
        return {
            ...estudante,
            anotacoes: anotacoesFiltradas
        };
    });
}


</script>
<template>
    <div class="flex gap-4 flex-column">
        <MultiSelect filter v-model="datasSelecionadas" display="chip" :options="datasComRegistro" placeholder="Data"
            class="w-full" />
        <MultiSelect filter v-model="planosSelecionados" display="chip" :options="opcoesPlanos" placeholder="Planos"
            class="w-full" optionLabel="titulo" optionValue="id" />
        <div class="flex gap-2 align-items-center"
            v-tooltip.top="'Veja somente alunos sem anotações na data selecionada'">
            <InputSwitch v-model="alunosSemAnotacoes" class="flex-shrink-0" />
            <div class="flex-shrink-0">Sem anotações</div>
        </div>
    </div>
</template>